import { trackEvent } from "@utils/analytics";

/*
  Hosts our pages are legitimately served under. Anything else means a third party is
  proxying or mirroring the site, which is the setup used for credential phishing.
  Deny-by-default is deliberate: a blocklist would only catch domains we already know about.
*/
const ALLOWED_HOSTS = [
  "mangomint.com",
  "netlify.app",
  "translate.goog", // Google Translate serves proxied pages under this domain
  "web.archive.org",
  "localhost",
  "127.0.0.1",
];

const isAllowedHost = (hostname) => ALLOWED_HOSTS.some((host) => hostname === host || hostname.endsWith(`.${host}`));

/*
  Report-only. Logs unexpected hosts without redirecting so we can review a few weeks of
  real traffic before enforcing. To enforce, replace the trackEvent call with:
  window.location.replace(`https://www.mangomint.com${window.location.pathname}`)
*/
export const reportUnexpectedHost = () => {
  if (typeof window === "undefined") return;

  const hostname = window.location.hostname.toLowerCase();
  if (!hostname || isAllowedHost(hostname)) return;

  trackEvent("Security: Unexpected Host", {
    hostname,
    path: window.location.pathname,
    referrer: document.referrer || "(none)",
  });
};
